import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class WebsiteModuleBolaoFloatingButtonRemoveEvent extends BaseAnalyticsEvent {
  source;

  constructor(params) {
    super('remove', 'floating-button', 'bolao');

    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }
}
